import { defineStore } from 'pinia'
import { ref } from '@nuxtjs/composition-api'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'

export const useCallWaiterModel = defineStore('call-waiter', () => {
  const showModal = ref<boolean>(false)
  const modalScrollWaiter = ref<boolean>(false)

  const toggleModal = () => {
    if (!showModal.value) {
      amplitudeLogEvent(amplitudeEvents.CALL_WAITER)
    }
    showModal.value = !showModal.value
  }

  return {
    showModal,
    modalScrollWaiter,
    toggleModal
  }
})
